module.exports = __webpack_public_path__ + "img/ba_live.fd838c69.svg";